import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  scrollView: {
    paddingBottom: 24,
    paddingHorizontal: 16,
  },
  contentContainer: {
    gap: 16,
  },
});
